<template>
  <div>
    <span
      v-if="item.status?.color"
      class="__status-dots"
      :style="{ backgroundColor: item.status.color }"
    ></span>
    <span class="mc-text-status">{{ computedStatus(item.status.raw_type) }}</span>
  </div>
</template>

<script>
import statuses from '@/router/views/sales-order/lib/constants/status'

export default {
  props: {
    item: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    computedStatus() {
      return (value) => {
        if (this.statusItems[value]) {
          return this.statusItems[value]?.label
        }

        return '-'
      }
    },
    
    statusItems() {
      return statuses(this)
    },
  }
}
</script>

<style lang="scss" scoped>
:deep(.__status-dots) {
  display: inline-block;
  margin: auto;
  width: 6px;
  height: 6px;
  border-radius: 50%;
  margin-right: 8px;
}
</style>